import { cn } from '@common/utils';

import { CustomLink } from '@/components/atom/CustomLink';
import { LazyImage } from '@/components/client';
import { ROUTES, STORAGE_KEY } from '@/constants';

interface RecommendHometownNewsVerticalCardProps {
  className?: string;
  idIdx: string;
  name: string;
  publishedAt: string;
  thumbnail: string;
}

export const RecommendHometownNewsVerticalCard = ({
  className,
  idIdx,
  name,
  publishedAt,
  thumbnail,
}: RecommendHometownNewsVerticalCardProps) => {
  const routePathname = ROUTES.HOMETOWN_NEWS_DETAIL.pathname({ idIdx: idIdx });

  const handleClick = () => {
    sessionStorage.setItem(
      STORAGE_KEY.HOMETOWN_NEWS_DETAIL_BOTTOM_DRAWER_PATH,
      routePathname,
    );
  };

  return (
    <CustomLink
      className={cn('flex h-244 w-161 flex-col gap-10', className)}
      href={routePathname}
      onClick={handleClick}
    >
      <LazyImage
        alt={name}
        className="size-160 rounded-medium border border-Gray-300"
        height={160}
        src={thumbnail}
        width={160}
      />
      <section className="flex h-73 flex-col justify-between gap-6">
        <h4 className="line-clamp-2 text-ellipsis break-all font-500 text-Gray-900 typo-body3">
          {name}
        </h4>
        <p className="font-400 text-Gray-600 typo-caption1">
          {publishedAt} 작성
        </p>
      </section>
    </CustomLink>
  );
};
